// Relative-time helper used by:
//   - BracketMode.LastUpdated (replaces inline "X min ago" math)
//   - GroupCard end-date display (replaces inline "Ended X days ago")
//   - ProfileTab Wager History (new caller)
//
// Returns 'just now' / 'N min ago' / 'N hour(s) ago' / 'N day(s) ago' /
// 'N week(s) ago' / 'N month(s) ago' / 'N year(s) ago'. Handles invalid
// input by returning '' (caller's responsibility to display fallback).

export function timeAgo(input) {
  if (input == null) return ''
  const ts = input instanceof Date ? input.getTime() :
             typeof input === 'number' ? input :
             typeof input === 'string' ? new Date(input).getTime() :
             NaN
  if (Number.isNaN(ts)) return ''

  const seconds = Math.floor((Date.now() - ts) / 1000)
  if (seconds < 60) return 'just now'

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`

  const days = Math.floor(hours / 24)
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`

  const weeks = Math.floor(days / 7)
  if (weeks < 4) return `${weeks} week${weeks === 1 ? '' : 's'} ago`

  const months = Math.floor(days / 30)
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`

  const years = Math.floor(days / 365)
  return `${years} year${years === 1 ? '' : 's'} ago`
}
